<app-alerts />

<app-admin-brand-details-form
  (submitClickEvent)="handleSubmitClickEvent($event)"
  [uploadFn]="uploadFn" />
